import { Component, Input } from '@angular/core';

@Component({
  selector: 'aas-date-value',
  templateUrl: './date-value.component.html'
})
export class DateValueComponent {
  @Input() id: string;
  @Input() value: string;
}
